export const productBlockTitle = '1. Продукты для подключения';
export const showAnotherProductsText = 'Показать другие продукты';
export const hideText = 'Скрыть';
export const rotateToRight = -90;
export const rotateToUp = 180;
export const productsUrlQuery = 'products[]';
